import { render, staticRenderFns } from "./asyncAppStart.vue?vue&type=template&id=6f70035a&"
import script from "./asyncAppStart.vue?vue&type=script&lang=js&"
export * from "./asyncAppStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports